import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/analytics'

const config = {
    apiKey: 'AIzaSyDdljBwhSeS1Aeibf5LDjId8_w2XIfDE64',
    authDomain: 'tempdeploy-1edd8.firebaseapp.com',
    projectId: 'tempdeploy-1edd8',
    storageBucket: 'tempdeploy-1edd8.appspot.com',
    messagingSenderId: '452047806113',
    appId: '1:452047806113:web:5bcd8bc084fec28f7f9ae0',
    databaseURL: 'https://tempdeploy-1edd8-default-rtdb.europe-west1.firebasedatabase.app/',
}

firebase.initializeApp(config)

export default firebase
